import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export function animation() {

  window.addEventListener('DOMContentLoaded', function () {

    // フェードイン5px上に上がる
    const fadeInElements = document.querySelectorAll(".js-fade-in");
    fadeInElements.forEach((element) => {
      gsap.fromTo(
        element,
        {
          opacity: 0,
          y: 15,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1.3,
          ease: "power4.out",
          scrollTrigger: {
            trigger: element, // トリガーとなる要素を指定
            start: "top 80%", // スクロール開始位置を指定
          },
        }
      );
    });
    // その場で出てくる
    const fadeIn = document.querySelectorAll(".js-fadeIn");
    fadeIn.forEach((element) => {
      gsap.fromTo(
        element,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 1.5,
          ease: "power4.out",
          scrollTrigger: {
            trigger: element, // トリガーとなる要素を指定
            start: "top 83%", // スクロール開始位置を指定
          },
        }
      );
    });

    const clipPathElements = document.querySelectorAll(".js-clip-path");
    clipPathElements.forEach((element) => {
      gsap.fromTo(
        element,
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1,
          webkitMaskImage: 'linear-gradient(to right, black 100%, transparent 100%)',
          maskImage: 'linear-gradient(to right, black 100%, transparent 100%)',
          duration: .5,
          ease: "power1.out",
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
          },
        }
      );
    });
  })

  document.addEventListener('DOMContentLoaded', function () {
    // matchMedia
    const mm = gsap.matchMedia();

    // 761px以上の時 PC
    mm.add('(min-width:761px)', () => {
      const cardWrappers = document.querySelectorAll('.js-card-wrapper');
      cardWrappers.forEach((wrapper) => {
        const cards = wrapper.querySelectorAll('.js-card');
        gsap.fromTo(cards, { autoAlpha: 0, y: 20 },
          {
            y: 0, autoAlpha: 1, stagger: .05, scrollTrigger: {
              trigger: wrapper,
              start: 'top 85%',
            }
          }
        );
      });
    });

    // 760px以下の時 sp
    mm.add('(max-width:760px)', function () {
      const cards = document.querySelectorAll('.js-card');
      // card card card cards
      cards.forEach((card) => {
        gsap.fromTo(card, { autoAlpha: 0, y: 20 }, {
          y: 0, autoAlpha: 1, scrollTrigger: {
            trigger: card,
            start: 'top 85%',
          }
        });
      });
    });
  });


}
